
import { useState } from 'react'
import getThresholdValueFlu from '../../../../utils/getThresholdValueFlu'
import getThresholdValue from '../../../../utils/getThresholdValue'
import colorAxis from './colorAxisFluIndex8Level'

export default function MapLegend(props) {
  const provider = props.provider
  const geojson = props.geojson
  const data_type = props?.data_type
  const thresholdVal = props.thresholdVal
  const [getistrue, setistrue] = useState(true)

  const toggleLayerColor = () => {
    setistrue(prev => {
      const newValue = !prev
      if (geojson?.current) {
        geojson.current.eachLayer(layer => {
          layer.setStyle({
            fillColor: newValue ? 'none' : (data_type?.toUpperCase() === 'FLU'
              ? getThresholdValueFlu(thresholdVal).color
              : getThresholdValue(thresholdVal).color),
            weight: 1,
            opacity: 1,
            color: (data_type?.toUpperCase() === 'FLU'
              ? getThresholdValueFlu(thresholdVal).OutlineColor
              : getThresholdValue(thresholdVal).OutlineColor),
            dashArray: '1.5',
            fillOpacity: 0.7,
          })
        })
      }
      return newValue
    })
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'right', gap: '10px' }}>
      <svg viewBox="0 20 500 5" height="50" width="530" align="center" {...props}>
        {/* Legend Rectangles */}
        <rect x="0" y="0" width="15" height="15" fill={colorAxis.dataClasses[8].color} stroke="#6F0A46" strokeWidth="1px"></rect>
        <rect x="18" y="0" width="15" height="15" fill={colorAxis.dataClasses[7].color} stroke="#941E63" strokeWidth="1px"></rect>
        <text x="40" y="12" style={{ fontSize: '12px', color: '#4B4D4F' }}>Very High</text>
        <rect x="105" y="0" width="15" height="15" fill={colorAxis.dataClasses[6].color} stroke={colorAxis.dataClasses[6].plotBorderColor} strokeWidth="1px"></rect>
        <rect x="123" y="0" width="15" height="15" fill={colorAxis.dataClasses[5].color} stroke={colorAxis.dataClasses[5].plotBorderColor} strokeWidth="1px"></rect>
        <text x="145" y="12" style={{ fontSize: '12px', color: '#4B4D4F' }}>High</text>
        <rect x="180" y="0" width="15" height="15" fill={colorAxis.dataClasses[4].color} stroke={colorAxis.dataClasses[4].plotBorderColor} strokeWidth="1px"></rect>
        <rect x="198" y="0" width="15" height="15" fill={colorAxis.dataClasses[3].color} stroke={colorAxis.dataClasses[3].plotBorderColor} strokeWidth="1px"></rect>
        <text x="220" y="12" style={{ fontSize: '12px', color: '#4B4D4F' }}>Moderate</text>
        <rect x="283" y="0" width="15" height="15" fill={colorAxis.dataClasses[2].color} stroke={colorAxis.dataClasses[2].plotBorderColor} strokeWidth="1px"></rect>
        <rect x="301" y="0" width="15" height="15" fill={colorAxis.dataClasses[1].color} stroke="#3C9A34" strokeWidth="1px"></rect>
        <text x="323" y="12" style={{ fontSize: '12px', color: '#4B4D4F' }}>Low/Minimal</text>
        <rect x="413" y="0" width="15" height="15" fill="#F3F3F3" stroke="#6D6F70" strokeWidth="1px"></rect>
        <text x="438" y="12" style={{ fontSize: '12px', color: '#4B4D4F' }}>No Data</text>
      </svg>
    </div>
  )
}
